var map = {
	"./boardwalk.png": "2fd2",
	"./cafedelmor.png": "3711",
	"./campagnia.png": "611f",
	"./chocolatebar.png": "46d8",
	"./edge.png": "2b03",
	"./hilton.png": "ac51",
	"./kantina.png": "ca17",
	"./kayumanis.png": "26ef",
	"./mamalous.png": "e54e",
	"./mireio.png": "58dc",
	"./mumtaz.png": "2125",
	"./palace.png": "d8af",
	"./shire.png": "3100",
	"./silversands.png": "6b40",
	"./woodlands.png": "b707"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7579";